import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContractsService } from '@api/contracts.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-list-revision-contracts',
  templateUrl: './list-revision-contracts.component.html',
  styleUrls: ['./list-revision-contracts.component.scss']
})
export class ListRevisionContractsComponent implements OnInit {
  revisionList
  startPage = 1;
  pageSize = 100;
  totalPage = 0;
  public destroy$ = new Subject<void>();
  constructor(private contractService: ContractsService , public router: Router, ) { }

  ngOnInit(): void {
    this.contractService.getContractsRevision(this.pageSize , this.startPage).pipe(takeUntil(this.destroy$ )).subscribe(
      (res: any) => {
        this.revisionList = res;
      }
    )
  }
  changeStatus(id) {
    const data = {contractId: id, approve: true}
    this.contractService.changeRevisionStatus(data).pipe(takeUntil(this.destroy$ )).subscribe(
      (res: any)=>{
      }
    )
  }
}
